<template>
  <base-button
    class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md ps-text-gray-700 ps-bg-gray-100 hover:ps-bg-gray-50 focus:ps-outline-none focus:ps-border-indigo-300 focus:ps-shadow-outline-indigo active:bg-brand-brown-200 transition ease-in-out duration-150"
    @button-click="$emit('button-click')"
    :disabled="disabled"
  >
    <slot />
  </base-button>
</template>

<script>
import BaseButton from './BaseButton'

export default {
  name: 'ButtonSecondary',
  props: {
    disabled: Boolean
  },
  components: {
    BaseButton
  }
}
</script>
